module.exports = __webpack_public_path__ + "img/admin1.10a3713b.png";